import { xp, JSPDF, db } from '../../src/main'
import drawingService from './drawing'
import hexRgb from 'hex-rgb'

export default {
  generatePdf: generatePdf,
  generateSheet: generateSheet,
  generatePdfSheet: generatePdfSheet
}

var knowledgeBase = {}
var allDrawingList = []
const GREEN = '#C6EFCE'
// const ORANGE = '#ED7D31'
// const BLUE = '#5B9BD5'
const LIGHT_ORANGE = '#FFE598'
const LIGHT_GREEN = '#C5E0B3'
const WHITE = '#FFFFFF'

async function generateSheet (selectedUnits, address, projectName) {
  let sheetData = await prepareSheetData(selectedUnits)
  // console.log(sheetData)
  await buildSheet(sheetData, address, projectName)
  return true
}

async function buildSheet (sheetData, address, projectName) {
  let dateObj = new Date(Date.now())
  let dateStr = dateObj.toLocaleString()
  const FILENAME = `${projectName}_MS.xlsx`

  return xp.fromBlankAsync().then(workbook => {
    const masterSheet = workbook.sheet(0)
    masterSheet.name('Drawing Summary')
    const project = masterSheet.cell('D1')
    project.value(projectName).style({ fontSize: 20 })
    const generateTime = masterSheet.cell('D2')
    generateTime.value(`GENERATED ON: ${dateStr}`).style({ fontColor: 'e53935', bold: true })

    // KITCHEN, VANITY, OTHER'S HEAD BAR
    const other = masterSheet.cell('D3')
    const kitchen = masterSheet.cell('D4')
    const vanity = masterSheet.cell('D5')
    other.value('OTHER')
    other.style({ bold: true, fill: 'ff8a80' })
    kitchen.value('KITCHEN')
    kitchen.style({ bold: true, fill: '2196f3' })
    vanity.value('VANITY')
    vanity.style({ bold: true, fill: 'ff9800' })
    const otherSum = masterSheet.cell('E3')
    const kitchenSum = masterSheet.cell('E4')
    const vanitySum = masterSheet.cell('E5')
    otherSum.value(sheetData.otherAmount).style({ bold: true, borderColor: '000000', border: true, fontColor: 'bf360c' })
    kitchenSum.value(sheetData.kitchenAmount).style({ bold: true, borderColor: '000000', border: true, fontColor: 'bf360c' })
    vanitySum.value(sheetData.vanityAmount).style({ bold: true, borderColor: '000000', border: true, fontColor: 'bf360c' })

    let kitchenBarLength = sheetData.pageTypeAmount.kitchenDrawingAmount * 2
    let vanityBarLength = sheetData.pageTypeAmount.vanityDrawingAmount * 2
    let otherBarLength = sheetData.pageTypeAmount.otherDrawingAmount * 2
    const kitchenBar = masterSheet.range(3, 6, 3, 5 + kitchenBarLength)
    kitchenBar.merged(true)
    const vanityBar = masterSheet.range(3, 6 + kitchenBarLength, 3, 5 + kitchenBarLength + vanityBarLength)
    vanityBar.merged(true)
    const otherBar = masterSheet.range(3, 6 + kitchenBarLength + vanityBarLength, 3, 5 + kitchenBarLength + vanityBarLength + otherBarLength)
    otherBar.merged(true)
    masterSheet.row(3).cell(6).value('KITCHEN').style({ bold: true, fill: '2196f3' })
    masterSheet.row(3).cell(6 + kitchenBarLength).value('VANITY').style({ bold: true, fill: 'ff9800' })
    masterSheet.row(3).cell(6 + kitchenBarLength + vanityBarLength).value('OTHER').style({ bold: true, fill: 'ff8a80' })

    // PAGE ID ROW
    for (let i = 0; i < sheetData.pageIdArray.length; i++) {
      masterSheet.row(4).cell(6 + 2 * i).value(sheetData.pageIdArray[i])
      masterSheet.row(4).cell(7 + 2 * i).value('')
    }

    // DETAIL TYPE ROW
    for (let i = 0; i < sheetData.drawingDetailTypeArray.length; i++) {
      masterSheet.row(5).cell(6 + 2 * i).value(sheetData.drawingDetailTypeArray[i])
      masterSheet.row(5).cell(7 + 2 * i).value('')
    }

    // ROOM TYPE ROW
    masterSheet.cell('D6').value('ROOM TYPE')
    for (let i = 0; i < sheetData.unitTypeArray.length; i++) {
      let str = sheetData.unitTypeArray[i].type
      let bgColor = sheetData.unitTypeArray[i].bg.slice(-6).toLowerCase()
      masterSheet.row(6).cell(6 + 2 * i).value(str)
      masterSheet.row(6).cell(6 + 2 * i).style({ fill: bgColor, wrapText: true, borderColor: 'bbbbbb', border: true })
      masterSheet.row(6).cell(7 + 2 * i).value('')
    }
    // HEAD ROW
    masterSheet.row(7).cell(1).value('Handles').style({ borderColor: 'bbbbbb', border: true, wrapText: true })
    masterSheet.row(7).cell(2).value('Hinges').style({ borderColor: 'bbbbbb', border: true, wrapText: true })
    masterSheet.row(7).cell(3).value('Glides').style({ borderColor: 'bbbbbb', border: true, wrapText: true })
    masterSheet.row(7).cell(4).value('ITEM').style({ borderColor: 'bbbbbb', border: true, wrapText: true })
    masterSheet.row(7).cell(5).value('TOTAL').style({ borderColor: 'bbbbbb', border: true, wrapText: true })
    for (let i = 0; i < sheetData.unitSummaryArray.length; i++) {
      masterSheet.row(7).cell(6 + 2 * i).value(sheetData.unitSummaryArray[i]).style({ wrapText: true })
    }
    for (let i = 0; i < sheetData.unitMultiplierArray.length; i++) {
      masterSheet.row(7).cell(7 + 2 * i).value(sheetData.unitMultiplierArray[i])
    }

    // LEFT ITEM HEAD
    for (let i = 0; i < sheetData.itemHead.length; i++) {
      let rowData = sheetData.itemHead[i]
      let itemBgColor = rowData.bg.slice(-6).toLowerCase()
      masterSheet.row(8 + i).cell(1).value(rowData.handle === 0 ? '' : rowData.handle).style({ fill: rowData.handle === 0 ? 'ffffff' : 'c6efce' })
      masterSheet.row(8 + i).cell(2).value(rowData.hinge === 0 ? '' : rowData.hinge).style({ fill: rowData.hinge === 0 ? 'ffffff' : 'c6efce' })
      masterSheet.row(8 + i).cell(3).value(rowData.glide === 0 ? '' : rowData.glide).style({ fill: rowData.glide === 0 ? 'ffffff' : 'c6efce' })
      masterSheet.row(8 + i).cell(4).value(rowData.str)
      masterSheet.row(8 + i).cell(4).style({ fill: itemBgColor, borderColor: 'bbbbbb', border: true, wrapText: true })
    }
    masterSheet.column(1).style({ borderColor: 'bbbbbb', border: true, wrapText: true, horizontalAlignment: 'center' })
    masterSheet.column(2).style({ borderColor: 'bbbbbb', border: true, wrapText: true, horizontalAlignment: 'center' })
    masterSheet.column(3).style({ borderColor: 'bbbbbb', border: true, wrapText: true, horizontalAlignment: 'center' })
    masterSheet.column(1).width(5)
    masterSheet.column(2).width(5)
    masterSheet.column(3).width(5)

    // ITEM TOTAL COLUMN
    for (let i = 0; i < sheetData.itemTotalArray.length; i++) {
      masterSheet.row(8 + i).cell(5).value(sheetData.itemTotalArray[i] === 0 ? '' : sheetData.itemTotalArray[i])
    }

    // QTY TABLE & TOTAL TABLE
    for (let i = 0; i < sheetData.itemQtyTable.length; i++) {
      let qtyRow = sheetData.itemQtyTable[i]
      let totalRow = sheetData.itemTotalTable[i]
      for (let j = 0; j < qtyRow.length; j++) {
        let bgColor = qtyRow[j].bg.slice(-6).toLowerCase()
        masterSheet.row(8 + i).cell(6 + j * 2).value(qtyRow[j].qty === 0 ? '' : qtyRow[j].qty).style({ fill: bgColor, borderColor: 'bbbbbb', border: true })
        masterSheet.row(8 + i).cell(7 + j * 2).value(totalRow[j].qty === 0 ? '' : totalRow[j].qty).style({ fill: bgColor, borderColor: 'bbbbbb', border: true })
      }
    }

    // CHANGE THE SIZE OF SPECIAL ROW
    masterSheet.column('D').width(50)

    // ============= BUILD PACKING SHEET ===============
    const packingSheet = workbook.addSheet('Packing Summary')

    // Top 6 row
    packingSheet.range('D1:E1').merged(true)
    packingSheet.row(1).cell(4).value(projectName).style({
      fontSize: 20
    })
    packingSheet.range('D2:E2').merged(true)
    packingSheet.row(2).cell(4).value(`GENERATED ON: ${dateStr}`).style({ fontColor: 'e53935', bold: true })

    packingSheet.row(3).cell(4).value('UNITS COUNT')
    packingSheet.row(4).cell(4).value(sheetData.packingUnitHeadArray.length)

    packingSheet.row(3).cell(4).value('VANITY SHOP DRAWING')
    packingSheet.row(4).cell(4).value('KITCHEN SHOP DRAWING')
    packingSheet.row(5).cell(4).value('OTHER SHOP DRAWING')

    packingSheet.row(6).cell(1).value('HANDLES')
    packingSheet.row(6).cell(2).value('HINGES')
    packingSheet.row(6).cell(3).value('GLIDES')
    packingSheet.row(6).cell(4).value('TOTAL')
    packingSheet.row(6).cell(5).value('ITEM')

    for (let i = 0; i < sheetData.packingUnitHeadArray.length; i++) {
      let unit = sheetData.packingUnitHeadArray[i]
      packingSheet.row(3).cell(6 + i).value(unit.pageIdTable.Vanity.join(','))
      packingSheet.row(4).cell(6 + i).value(unit.pageIdTable.Kitchen.join(','))
      packingSheet.row(5).cell(6 + i).value(unit.pageIdTable.Other.join(','))
      // 19MAR#1
      packingSheet.row(6).cell(6 + i).value(`${unit.display}${unit.building === 'Default' ? '' : '\n[' + unit.building + ']'}`)
    }
    // style top 5 row
    packingSheet.row(3).style({ horizontalAlignment: 'center', borderColor: 'bbbbbb', border: true, wrapText: true, verticalAlignment: 'center' })
    packingSheet.row(4).style({ horizontalAlignment: 'center', borderColor: 'bbbbbb', border: true, wrapText: true, verticalAlignment: 'center' })
    packingSheet.row(5).style({ horizontalAlignment: 'center', borderColor: 'bbbbbb', border: true, wrapText: true, verticalAlignment: 'center' })
    packingSheet.row(6).style({ horizontalAlignment: 'center', fill: 'd0d0d0', bold: true, borderColor: 'bbbbbb', border: true, wrapText: true, verticalAlignment: 'center' })
    packingSheet.row(3).cell(5).style({ horizontalAlignment: 'right', bold: true })
    packingSheet.row(4).cell(5).style({ horizontalAlignment: 'right', bold: true })
    packingSheet.row(5).cell(5).style({ horizontalAlignment: 'right', bold: true })
    packingSheet.row(6).cell(4).style({ bold: true })

    // file 3 most left column (HHG data)
    for (let i = 0; i < sheetData.itemHead.length; i++) {
      let rowData = sheetData.itemHead[i]
      packingSheet.row(10 + i).cell(1).value(rowData.handle === 0 ? '' : rowData.handle).style({ fill: rowData.handle === 0 ? 'ffffff' : 'c6efce' })
      packingSheet.row(10 + i).cell(2).value(rowData.hinge === 0 ? '' : rowData.hinge).style({ fill: rowData.hinge === 0 ? 'ffffff' : 'c6efce' })
      packingSheet.row(10 + i).cell(3).value(rowData.glide === 0 ? '' : rowData.glide).style({ fill: rowData.glide === 0 ? 'ffffff' : 'c6efce' })
    }
    packingSheet.column(1).style({ borderColor: 'bbbbbb', border: true, wrapText: true, horizontalAlignment: 'center' })
    packingSheet.column(2).style({ borderColor: 'bbbbbb', border: true, wrapText: true, horizontalAlignment: 'center' })
    packingSheet.column(3).style({ borderColor: 'bbbbbb', border: true, wrapText: true, horizontalAlignment: 'center' })
    packingSheet.column(1).width(5)
    packingSheet.column(2).width(5)
    packingSheet.column(3).width(5)

    // fill total column
    for (let i = 0; i < sheetData.packingTotalArray.length; i++) {
      packingSheet.row(i + 7).cell(4).value(sheetData.packingTotalArray[i] === 0 ? '' : sheetData.packingTotalArray[i])
    }
    packingSheet.column(4).style({ horizontalAlignment: 'center' })
    packingSheet.column(4).width(15)

    // fill item head column
    for (let i = 0; i < sheetData.packingItemHead.length; i++) {
      let item = sheetData.packingItemHead[i]
      let bgColor = item.bg.slice(-6).toLowerCase()
      packingSheet.row(7 + i).cell(5).value(item.str).style({
        fill: bgColor,
        wrapText: true,
        borderColor: 'bbbbbb',
        border: true
      })
    }
    packingSheet.column(5).width(50)

    // fill qty table
    for (let i = 0; i < sheetData.packingQtyTable.length; i++) {
      let row = sheetData.packingQtyTable[i]
      for (let j = 0; j < row.length; j++) {
        // write only if the value not zero
        let qty = row[j]
        if (qty !== 0) {
          packingSheet.row(7 + i).cell(6 + j).value(qty).style({
            horizontalAlignment: 'center',
            fill: 'c6efce',
            borderColor: 'bbbbbb',
            border: true
          })
        } else {
          // zero qty cell will only style the border
          packingSheet.row(7 + i).cell(6 + j).value('').style({
            horizontalAlignment: 'center',
            borderColor: 'bbbbbb',
            border: true
          })
        }
      }
    }

    // ============== WRITE OUT THE SPREADSHEET =================
    return workbook.outputAsync()
  }).then(blob => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // If IE, you must uses a different method.
      window.navigator.msSaveOrOpenBlob(blob, FILENAME)
    } else {
      var url = window.URL.createObjectURL(blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = FILENAME
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  })
}

async function generatePdf (selectedUnits, address, projectName) {
  let pdfData = await preparePackingPdfData(selectedUnits)
  await buildPdf(pdfData, address, projectName)
  return true
}

async function buildPdf (pdfData, address, projectName) {
  let date = new Date(Date.now())
  let dateString = date.toLocaleDateString()

  let hPosition = 32
  let vPosition = 100

  let packingPDF = new JSPDF({
    orientation: 'portrait',
    unit: 'pt',
    format: 'letter'
  })
  // Main Title
  packingPDF.setFontSize(46)
  packingPDF.text('Packing Work Order', hPosition, vPosition)
  vPosition += 446
  // Project Name
  packingPDF.setFontSize(22)
  packingPDF.text(projectName, hPosition, vPosition)
  vPosition += 36
  // Delivery Address
  packingPDF.setFontSize(22)
  packingPDF.text(address, hPosition, vPosition)
  vPosition += 36
  // Print Date
  packingPDF.text('Print Date: ' + dateString, hPosition, vPosition)
  vPosition += 36
  // Delivery Date
  packingPDF.text('Delivery Date:          /      /    ', hPosition, vPosition)
  vPosition += 36

  for (let i = 0; i < pdfData.length; i++) {
    let page = pdfData[i]
    packingPDF.addPage()
    let hPosition = 32
    let vPosition = 30

    // add page head
    packingPDF.setFontSize(8)
    packingPDF.text(projectName, hPosition, vPosition)
    vPosition += 12
    packingPDF.text(address, hPosition, vPosition)
    vPosition += 12
    packingPDF.text('Print Date: ' + dateString, hPosition, vPosition)
    vPosition += 12
    packingPDF.text('Delivery Date:          /          /    ', hPosition, vPosition)
    vPosition += 12
    packingPDF.text(`UNIT ${i + 1} of ${pdfData.length}`, hPosition, vPosition)
    vPosition += 20

    // add unit id
    packingPDF.setFontSize(10)
    packingPDF.text('Building: ' + page.building, hPosition, vPosition)
    vPosition += 8

    packingPDF.setFontSize(8)
    packingPDF.text('Unit: ', hPosition, vPosition)
    vPosition += 25

    packingPDF.setFontSize(20)
    packingPDF.text(page.unit, hPosition + 20, vPosition)
    vPosition += 20

    // add drawing summary table
    let drawingTable = page.drawingSummary.map(drawing => {
      return [drawing.type, drawing.page, drawing.revision, drawing.updateOn]
    })
    packingPDF.setFontSize(8)
    if (drawingTable.length > 0) {
      packingPDF.autoTable(
        ['Drawing Type', 'Page Number', 'Revision', 'Last Update On'],
        drawingTable,
        {
          startY: vPosition,
          theme: 'plain',
          styles: { cellPadding: 0.5, fontSize: 8 }
        }
      )
    } else {
      packingPDF.setFontSize(22)
      packingPDF.text('====== NO DATA FOUND FOR THIS UNIT ======', hPosition, vPosition + 30)
    }

    // add item group tables
    for (let itemTable of page.itemTables) {
      if (itemTable.items.length > 0) {
        let tableHead = [
          { title: '', dataKey: 'check' },
          { title: '', dataKey: 'qty' },
          { title: itemTable.color, dataKey: 'model' }
        ]
        let tableData = itemTable.items.map(item => {
          return {
            qty: item.qty,
            check: '[    ]',
            model: item.model
          }
        })
        packingPDF.autoTable(
          tableHead,
          tableData,
          {
            startY: packingPDF.autoTable.previous.finalY + 10,
            theme: 'striped',
            bodyStyles: { valign: 'middle' },
            styles: { overflow: 'linebreak', columnWidth: 'auto', cellPadding: 0.8, fontSize: 10 },
            columnStyles: {
              qty: { columnWidth: 40, halign: 'center' },
              check: { columnWidth: 40 }
            }
          }
        )
      }
    }
  }
  packingPDF.save(`${projectName}_PO.pdf`)
}

async function generatePdfSheet (selectedUnits, headerInfo) {
  let sheetData = await prepareSheetData(selectedUnits)
  // console.log(sheetData)
  // console.log('headerInfo =>', headerInfo)
  await buildPdfSheet(sheetData, headerInfo)
  return true
}

async function buildPdfSheet (sheetData, headerInfo) {
  const LONG_CELL_WIDTH = 40

  const LIGHT_GREEN_RGB = [hexRgb(LIGHT_GREEN).red, hexRgb(LIGHT_GREEN).green, hexRgb(LIGHT_GREEN).blue]
  // console.log(sheetData.packingUnitHeadArray)
  // console.log(LIGHT_GREEN_RGB)
  // ====== prepare data for auto-table =======
  let table = []
  let blankCell = { content: '', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold' } }
  // top 4 rows
  // row 1
  let unitHeadCell = { content: 'Unit', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold' } }
  let vanityHeadCell = { content: 'VANITY SHOP DRAWING', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold', cellWidth: LONG_CELL_WIDTH, halign: 'right', overflow: 'linebreak' } }

  let row1 = [/*blankCell, blankCell, blankCell,*/unitHeadCell, vanityHeadCell] // eslint-disable-line
  for (let i = 0; i < sheetData.packingUnitHeadArray.length; i++) {
    let unit = sheetData.packingUnitHeadArray[i]
    let pageIdCell = { content: unit.pageIdTable.Vanity.join(','), rowSpan: 1, colSpan: 1, styles: { halign: 'center', overflow: 'linebreak' } }
    row1.push(pageIdCell)
  }
  // row 2
  let unitAmountCell = { content: String(sheetData.packingUnitHeadArray.length), rowSpan: 1, colSpan: 1, styles: { fontStyle: 'normal' } }
  let kitchenHeadCell = { content: 'KITCHEN SHOP DRAWING', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold', cellWidth: LONG_CELL_WIDTH, halign: 'right', overflow: 'linebreak' } }
  let row2 = [/*blankCell,blankCell,blankCell,*/unitAmountCell, kitchenHeadCell] // eslint-disable-line
  for (let i = 0; i < sheetData.packingUnitHeadArray.length; i++) {
    let unit = sheetData.packingUnitHeadArray[i]
    let pageIdCell = { content: unit.pageIdTable.Kitchen.join(','), rowSpan: 1, colSpan: 1, styles: { halign: 'center', overflow: 'linebreak' } }
    row2.push(pageIdCell)
  }
  // row 3
  let otherHeadCell = { content: 'OTHER SHOP DRAWING', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold', cellWidth: LONG_CELL_WIDTH, halign: 'right', overflow: 'linebreak' } }
  let row3 = [/*blankCell,blankCell,blankCell,*/blankCell, otherHeadCell] // eslint-disable-line
  for (let i = 0; i < sheetData.packingUnitHeadArray.length; i++) {
    let unit = sheetData.packingUnitHeadArray[i]
    let pageIdCell = { content: unit.pageIdTable.Other.join(','), rowSpan: 1, colSpan: 1, styles: { halign: 'center', overflow: 'linebreak' } }
    row3.push(pageIdCell)
  }
  // row 4
  // let handleHeadCell = {content: 'HANDLES', rowSpan: 1, colSpan: 1, styles: {fontStyle: 'bold',fillColor: 200}}
  // let hingeHeadCell = {content: 'HINGES', rowSpan: 1, colSpan: 1, styles: {fontStyle: 'bold',fillColor: 200}}
  // let glideHeadCell = {content: 'GLIDES', rowSpan: 1, colSpan: 1, styles: {fontStyle: 'bold',fillColor: 200}}
  let totalHeadCell = { content: 'TOTAL', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold', fillColor: 200 } }
  let itemHeadCell = { content: 'ITEM', rowSpan: 1, colSpan: 1, styles: { fontStyle: 'bold', fillColor: 200, cellWidth: LONG_CELL_WIDTH } }

  let row4 = [/*handleHeadCell,hingeHeadCell,glideHeadCell,*/totalHeadCell, itemHeadCell] // eslint-disable-line
  for (let i = 0; i < sheetData.packingUnitHeadArray.length; i++) {
    let unit = sheetData.packingUnitHeadArray[i]
    let unitNumberCell = { content: `${unit.display}${unit.building === 'Default' ? '' : '\n[' + unit.building + ']'}`, rowSpan: 1, colSpan: 1, styles: { halign: 'center', overflow: 'linebreak', fontStyle: 'bold', fillColor: 200 } }
    row4.push(unitNumberCell)
  }
  table = [row1, row2, row3, row4] // row4 is not necessary in obj table
  // THE REST ROWS
  for (let i = 0; i < sheetData.packingItemHead.length; i++) {
    let normalRow = []
    let rowData = sheetData.itemHead[i] // eslint-disable-line
    // hhg cells

    // let handleCell = {content: rowData.handle === 0 ? '' : String(rowData.handle), rowSpan: 1, colSpan: 1, styles: {fillColor: rowData.handle === 0 ? false : LIGHT_GREEN_RGB}}
    // let hingeCell = {content: rowData.hinge === 0 ? '' : String(rowData.hinge), rowSpan: 1, colSpan: 1, styles: {fillColor: rowData.hinge === 0 ? false : LIGHT_GREEN_RGB}}
    // let glideCell = {content: rowData.glide === 0 ? '' : String(rowData.glide), rowSpan: 1, colSpan: 1, styles: {fillColor: rowData.glide === 0 ? false : LIGHT_GREEN_RGB}}

    // total cell
    let totalCell = { content: sheetData.packingTotalArray[i] === 0 ? '' : String(sheetData.packingTotalArray[i]), rowSpan: 1, colSpan: 1, styles: { fillColor: sheetData.packingTotalArray[i] === 0 ? false : LIGHT_GREEN_RGB } }
    // item name cell
    let bgColor = sheetData.packingItemHead[i].bg.slice(-6).toLowerCase()
    let bgColorRGB = [hexRgb(bgColor).red, hexRgb(bgColor).green, hexRgb(bgColor).blue]
    let itemNameCell = { content: sheetData.packingItemHead[i].str || '', rowSpan: 1, colSpan: 1, styles: { fillColor: bgColorRGB, cellWidth: LONG_CELL_WIDTH, overflow: 'linebreak' } }

    normalRow = [/*handleCell,hingeCell,glideCell,*/totalCell, itemNameCell] // eslint-disable-line

    // qty cells
    let qtyRowData = sheetData.packingQtyTable[i]
    for (let j = 0; j < qtyRowData.length; j++) {
      // write only if the value not zero
      let qty = qtyRowData[j]
      let qtyCell = { content: qty === 0 ? '' : String(qty), rowSpan: 1, colSpan: 1, styles: { fillColor: qty === 0 ? false : LIGHT_GREEN_RGB } }
      normalRow.push(qtyCell)
    }
    table.push(normalRow)
  }
  let columns = [
    /*{title: 'HAN', dataKey: 'handles'},{title: 'HIN', dataKey: 'hinges'},{title: 'GLI', dataKey: 'glides'},*/{ title: 'TOTAL', dataKey: 'total' }, { title: 'ITEM', dataKey: 'item' } // eslint-disable-line
  ]
  let unitNumRow = table[3]
  let columnStyles = {
    // handles: {columnWidth: 25},
    // hinges: {columnWidth: 25},
    // glides: {columnWidth: 25},
    total: { columnWidth: 60 },
    item: { columnWidth: 160, fontSize: 10, halign: 'left' }
  }
  // calculate the column width and font size of the sheet
  let colWidth = 900 / (unitNumRow.length - 2)
  let fontSize = 10

  for (let i = 2; i < unitNumRow.length; i++) {
    let unitNum = unitNumRow[i].content
    let newColumn = {
      title: String(unitNum),
      dataKey: `key_${unitNum}`
    }
    columnStyles[newColumn.dataKey] = {
      columnWidth: colWidth,
      fontSize: fontSize,
      halign: 'center',
      valign: 'bottom',
      overflow: 'linebreak',
      cellPadding: {bottom: 5}
    }
    columns.push(newColumn)
  }
  // console.log(columnStyles)

  // parse array style table to object style table (from [[{},{}],[{},{}],[{},{}]] to [{key1:{}, key2:{}},{key1:{}, key2:{}},{key1:{}, key2:{}}])
  let objStyleTable = []
  let dataKeysArray = []
  for (let i = 0; i < columns.length; i++) {
    dataKeysArray.push(columns[i].dataKey)
  }
  for (let i = 0; i < table.length; i++) {
    if (i === 3) {
      continue // skip item row
    }
    let arrayRow = table[i]
    // console.log(arrayRow)
    let objRow = {}
    for (let j = 0; j < arrayRow.length; j++) {
      let dataKey = dataKeysArray[j]
      objRow[dataKey] = arrayRow[j]
    }
    objStyleTable.push(objRow)
  }
  // console.log(objStyleTable)

  // ======= generate the table ======
  // set pdf page property
  let result = generatePdfWithTable(columns, objStyleTable, columnStyles)
  let packingSheetPdf = result.pdf
  let pageCounter = result.totalPage

  // INVESTIGATE IF THE AREA LEFT IS ENOUGH TO PUT THE SIGN AREA
  if (packingSheetPdf.autoTable.previous.finalY > 700) {
    // Area is not enough, calculate and regenerate the table
    // calculate the increase margin
    let increase = Math.ceil((842 + 100 - Math.floor(packingSheetPdf.autoTable.previous.finalY)) / pageCounter)
    let newMargin = 30 + increase
    // console.log('New Margin =>', newMargin)
    // get a new pdf
    result = generatePdfWithTable(columns, objStyleTable, columnStyles, newMargin)
    packingSheetPdf = result.pdf
    pageCounter = result.totalPage
  }

  const amberLeafLogo = 'data:image/png;base64,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'
  const deliverInfo = [
    'Ship To:\n',
    headerInfo.projectName + '\n',
    headerInfo.address + '\n',
    headerInfo.phone
  ]
  for (let i = 1; i <= pageCounter; i++) {
    packingSheetPdf.setPage(i)

    // LOGO
    packingSheetPdf.addImage(amberLeafLogo, 'PNG', 50, 50, 200, 60)

    // DELIVERY INFO
    packingSheetPdf.setFontSize(8)
    packingSheetPdf.text(deliverInfo, 1150, 75, {
      align: 'right',
      maxWidth: 300
    })

    // TITLE
    packingSheetPdf.setFontSize(16)
    let title = [
      headerInfo.projectName,
      '\n',
      'DELIVERY DATE:         /           /    '
    ]
    packingSheetPdf.text(title, 600, 50, {
      align: 'center',
      maxWidth: 500
    })

    // PAGE NUMBER AND FOOTER
    packingSheetPdf.setFontSize(8)
    let date = new Date()
    let footer = `Printed On: ${date.toLocaleString('en-US')} [ Page ${i} of ${pageCounter} ]`

    packingSheetPdf.text(footer, 600, 825, {
      align: 'center',
      maxWidth: 600
    })
  }
  // SIGN AREA ON LAST PAGE
  let signArea = 'Signature: ______________________ Print: _____________________ Date: ________________'
  let warningTitle = 'Please make sure you received the items before sign'
  let warning = 'Any claims regarding damaged items or missing items, MUST report to Amberleafcabinetry via an email within 72 Hours.Otherwise, Amberleafcabinetry WILL NOT be responsible for any damaged and/or missing items.Thanks for your cooperation!'
  packingSheetPdf.setFontSize(14)
  packingSheetPdf.text(warningTitle, 600, packingSheetPdf.autoTable.previous.finalY + 35, {
    align: 'center'
  })
  packingSheetPdf.setFontSize(8)
  packingSheetPdf.text(warning, 600, packingSheetPdf.autoTable.previous.finalY + 50, {
    align: 'center',
    maxWidth: 500
  })
  packingSheetPdf.setFontSize(16)
  packingSheetPdf.text(signArea, 600, packingSheetPdf.autoTable.previous.finalY + 90, {
    align: 'center'
  })
  packingSheetPdf.save(`${headerInfo.projectName}_PS.pdf`)
  return null
}

function generatePdfWithTable (columns, objStyleTable, columnStyles, margin = 30) {
  let packingSheetPdf = new JSPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'a3'
  })

  // generate new table
  let pageCounter = 1
  packingSheetPdf.autoTable(columns, objStyleTable, {
    theme: 'grid',
    margin: { top: 120, bottom: margin },
    styles: {
      fontSize: 12,
      halign: 'center',
      valign: 'middle',
      cellWidth: 25,
      overflow: 'linebreak',
      fontStyle: 'bold',
      minCellHeight: 20
    },
    // headStyles: {fontSize: 12,halign: 'center',valign: 'middle',cellWidth: 25,overflow: 'linebreak'},
    columnStyles: columnStyles,
    rowPageBreak: 'avoid',
    createdCell: function (cell, data) {
      // console.log(data.cell)
      data.cell.text[0] = data.cell.raw.content
      let styles = data.cell.raw.styles
      for (let prop in styles) {
        data.cell.styles[prop] = styles[prop]
      }
    },
    addPageContent: function (data) {
      // console.log('Page add', data)
      pageCounter = data.pageCount
    }
  })
  return {
    pdf: packingSheetPdf,
    totalPage: pageCounter
  }
}

async function preparePackingPdfData (selectedUnits) {
  let unitsData = selectedUnits
  let projectId = unitsData[0].projectId
  let remoteDrawingData = await fetchDrawingData(unitsData.map(unit => { return unit.unitId }))
  knowledgeBase = await drawingService.fetchProjectKnowledgeBase(projectId)
  let groupDrawings = groupDrawingList(remoteDrawingData)
  allDrawingList = joinDrawingGroup(groupDrawings)
  allDrawingList = addUnitInfo()
  let fullItemList = fetchFullItemList()
  let packingItemHead = getItemDisplayArray(fullItemList)
  let packingUnitHead = getUnitsHeadArray(unitsData)
  let packingQtyTable = calcPackingQtyTable(packingUnitHead, packingItemHead)

  // Start assemble final pdf data

  let pdfPages = []
  for (let unitIndex = 0; unitIndex < packingUnitHead.length; unitIndex++) {
    let unit = packingUnitHead[unitIndex]

    // assemble drawing summary table
    let drawingSummary = []
    for (let pageId of unit.pageIdTable.Kitchen) {
      let summary = {
        type: 'KITCHEN',
        page: pageId,
        revision: fetchPageInfo(pageId).revision,
        updateOn: fetchPageInfo(pageId).updateOn
      }
      drawingSummary.push(summary)
    }
    for (let pageId of unit.pageIdTable.Vanity) {
      let summary = {
        type: 'VANITY',
        page: pageId,
        revision: fetchPageInfo(pageId).revision,
        updateOn: fetchPageInfo(pageId).updateOn
      }
      drawingSummary.push(summary)
    }
    for (let pageId of unit.pageIdTable.Other) {
      let summary = {
        type: 'OTHER',
        page: pageId,
        revision: fetchPageInfo(pageId).revision,
        updateOn: fetchPageInfo(pageId).updateOn
      }
      drawingSummary.push(summary)
    }

    // ASSEMBLE ITEM TABLE
    let itemTables = []
    let currentTable = {
      color: packingItemHead[0].str,
      bg: packingItemHead[0].bg,
      items: []
    }
    for (let itemIndex = 1; itemIndex < packingItemHead.length; itemIndex++) {
      let item = packingItemHead[itemIndex]
      if (item.itemId === 'COLOR_HEAD') {
        // ADD NEW TABLE AND PUSH OLD TABLE
        itemTables.push(currentTable)
        currentTable = {
          color: packingItemHead[itemIndex].str,
          bg: packingItemHead[itemIndex].bg,
          items: []
        }
      } else {
        // ADD NEW ITEM TO CURRENT TABLE IF QTY GRATER THAN 0
        let qty = packingQtyTable[itemIndex][unitIndex]
        if (qty > 0) {
          currentTable.items.push({
            model: item.str,
            qty: qty
          })
        }
      }
    }
    itemTables.push(currentTable) // push last item table

    // PUSH PAGE DATA
    pdfPages.push({
      unit: unit.display,
      building: unit.building,
      drawingSummary: drawingSummary,
      itemTables: itemTables
    })
  }
  // let pdfData = {
  //     allDrawingList: allDrawingList,
  //     packingItemHead: packingItemHead,
  //     packingUnitHead: packingUnitHead,
  //     packingQtyTable: packingQtyTable,
  //     pdfPages: pdfPages
  // }
  return pdfPages
}

async function prepareSheetData (selectedUnits) {
  let unitsData = selectedUnits
  let projectId = unitsData[0].projectId
  let remoteDrawingData = await fetchDrawingData(unitsData.map(unit => { return unit.unitId }))
  knowledgeBase = await drawingService.fetchProjectKnowledgeBase(projectId)
  // console.log(knowledgeBase)

  // ===== DRAWING SHEET DATA ======

  let groupDrawings = groupDrawingList(remoteDrawingData)
  // console.log(groupDrawings)

  // console.log('unitsAmount', unitsAmount)
  allDrawingList = joinDrawingGroup(groupDrawings)
  // console.log(allDrawingList)
  allDrawingList = addUnitInfo()
  let unitsAmount = countUnitsAmountWithDuplicate(allDrawingList)
  // console.log('allDrawingList', allDrawingList)
  let fullItemList = fetchFullItemList()
  // console.log('fullItemList', fullItemList)
  let itemDisplayArray = getItemDisplayArray(fullItemList)
  // console.log('ItemDisplayArray', itemDisplayArray)
  let unitMultiplierArray = allDrawingList.map(drawingData => {
    return drawingData.units.length
  })
  // console.log('unitMultiplierArray', unitMultiplierArray)
  let itemQtyTable = getItemQtyTable(allDrawingList, itemDisplayArray)
  // console.log('itemQtyTable', itemQtyTable)
  let itemTotalTable = getItemTotalTable(itemQtyTable, unitMultiplierArray)
  // console.log('itemTotalTable', itemTotalTable)
  let itemTotalArray = getItemTotalArray(itemTotalTable)
  // console.log('itemTotalArray', itemTotalArray)
  let pageIdArray = allDrawingList.map(drawing => {
    return drawing.pageId
  })
  // console.log('pageIdArray', pageIdArray)
  let drawingDetailTypeArray = allDrawingList.map(drawing => {
    return drawing.detailType
  })
  // console.log('drawingDetailTypeArray', drawingDetailTypeArray)
  let unitTypeArray = allDrawingList.map(drawing => {
    let unitType = drawing.unitTypeStr
    if (unitType.indexOf('2 BED') !== -1 || unitType.indexOf('3 BED') !== -1) {
      return {
        type: unitType,
        bg: LIGHT_ORANGE
      }
    } else {
      return {
        type: unitType,
        bg: LIGHT_GREEN
      }
    }
  })
  // console.log('unitTypeArray', unitTypeArray)
  let unitSummaryArray = allDrawingList.map(drawing => {
    return drawing.unitStr
  })
  // console.log('unitSummaryArray', unitSummaryArray)
  // console.log(allDrawingList)
  let pageTypeAmount = getPageTypeAmount(allDrawingList)
  // console.log(pageTypeAmount)

  // ====== PACKING SHEET DATA ======
  let packingUnitHeadArray = getUnitsHeadArray(unitsData)
  // console.log('unitsHeadArray', unitsHeadArray)
  let packingQtyTable = calcPackingQtyTable(packingUnitHeadArray, itemDisplayArray)
  // console.table(packingQtyTable)
  let packingTotalArray = calcPackingTotalTable(packingQtyTable)
  // console.table(packingTotalArray)

  let sheetData = {
    // DRAWING SHEET DATA
    kitchenAmount: unitsAmount.kitchenAmount,
    vanityAmount: unitsAmount.vanityAmount,
    otherAmount: unitsAmount.otherAmount,
    pageIdArray: pageIdArray,
    drawingDetailTypeArray: drawingDetailTypeArray,
    unitTypeArray: unitTypeArray,
    unitSummaryArray: unitSummaryArray,
    unitMultiplierArray: unitMultiplierArray,
    itemHead: itemDisplayArray,
    itemTotalArray: itemTotalArray,
    itemQtyTable: itemQtyTable,
    itemTotalTable: itemTotalTable,
    pageTypeAmount: pageTypeAmount,
    // PACKING SHEET DATA
    packingUnitHeadArray: packingUnitHeadArray,
    packingItemHead: itemDisplayArray,
    packingTotalArray: packingTotalArray,
    packingQtyTable: packingQtyTable
  }

  // console.log('SHEET DATA => ', sheetData)
  // console.log('FINISH')
  return sheetData
}

async function fetchDrawingData (unitIdList) {
  try {
    let drawingGroups = await fetchDrawingGroups(unitIdList)
    // console.log(drawingGroups)
    // kick duplicated drawings and assemble drawing list
    let drawingIdList = []
    let drawingDataList = []
    for (let drawingGroup of drawingGroups) {
      for (let drawing of drawingGroup) {
        if (drawing.removed || !drawing.activePage) {
          continue
        }
        let drawingId = drawing.drawingId
        if (!drawingIdList.includes(drawingId)) {
          drawingIdList.push(drawingId)
          drawingDataList.push(drawing)
        }
      }
    }
    return drawingDataList
  } catch (err) {
    console.warn(err)
    return []
  }
}

async function fetchDrawingGroups (unitIdList) {
  let remoteFetchOperations = []
  // console.log(unitIdList)
  for (let unitId of unitIdList) {
    remoteFetchOperations.push(
      // assemble promise group
      // multiple drawing may be fetched for each group
      db.collection('drawings').where('units', 'array-contains', unitId).get().then(querySnapshot => {
        let size = querySnapshot.size
        // console.info(`${size} drawings found for units => ${unitId}`)
        if (size === 0) {
          // console.warn(`No drawing found for unit, unitId => ${unitId}`)
        }
        let singleGroup = []
        querySnapshot.forEach(doc => {
          singleGroup.push(doc.data())
        })
        return singleGroup
      }).catch(err => {
        console.warn(err)
        throw new Error(`Error while fetching drawing group for unit, unitId => ${unitId}`)
      })

    )
  }
  // console.log('return the promise list')
  try {
    let result = await Promise.all(remoteFetchOperations)
    return result
  } catch (err) {
    console.warn(err)
    return []
  }
}

function groupDrawingList (remoteDrawing) {
  let kitchenDrawing = []
  let vanityDrawing = []
  let otherDrawing = []
  for (let drawing of remoteDrawing) {
    if (drawing.type === 'Kitchen') {
      kitchenDrawing.push(drawing)
    } else if (drawing.type === 'Vanity') {
      vanityDrawing.push(drawing)
    } else {
      otherDrawing.push(drawing)
    }
  }
  kitchenDrawing.sort(comparePageId)
  vanityDrawing.sort(comparePageId)
  otherDrawing.sort(comparePageId)
  return {
    kitchen: kitchenDrawing,
    vanity: vanityDrawing,
    other: otherDrawing
  }
}

function comparePageId (drawingA, drawingB) {
  let numberRegex = /\d+(\.\d+)?/
  let pageA = drawingA.pageId.match(numberRegex) === null ? null : parseFloat(drawingA.pageId.match(numberRegex)[0])
  let pageB = drawingB.pageId.match(numberRegex) === null ? null : parseFloat(drawingB.pageId.match(numberRegex)[0])
  if (pageA === null && pageB === null) {
    return drawingA.pageId.localCompare(drawingB.pageId)
  } else if (pageA === null) {
    return 1
  } else {
    return pageA - pageB
  }
}

function countUnitsAmount(groupDrawings) { // eslint-disable-line
  let kitchenUnits = []
  let vanityUnits = []
  let otherUnits = []
  for (let drawing of groupDrawings.kitchen) {
    let units = drawing.units
    for (let unitId of units) {
      if (!kitchenUnits.includes(unitId)) {
        kitchenUnits.push(unitId)
      }
    }
  }
  for (let drawing of groupDrawings.vanity) {
    let units = drawing.units
    for (let unitId of units) {
      if (!vanityUnits.includes(unitId)) {
        vanityUnits.push(unitId)
      } else {
        // console.log(`duplicate found, drawing =  ${drawing.pageId}, unitId = ${unitId}`)
      }
    }
  }
  for (let drawing of groupDrawings.other) {
    let units = drawing.units
    for (let unitId of units) {
      if (!otherUnits.includes(unitId)) {
        otherUnits.push(unitId)
      }
    }
  }
  return {
    kitchenAmount: kitchenUnits.length,
    vanityAmount: vanityUnits.length,
    otherAmount: otherUnits.length
  }
}

function countUnitsAmountWithDuplicate (allDrawingList) {
  let kitchenSum = 0
  let vanitySum = 0
  let otherSum = 0
  for (let drawing of allDrawingList) {
    switch (drawing.type) {
      case 'Kitchen':
        kitchenSum += drawing.units.length
        break
      case 'Vanity':
        vanitySum += drawing.units.length
        break
      default:
        otherSum += drawing.units.length
    }
  }
  return {
    kitchenAmount: kitchenSum,
    vanityAmount: vanitySum,
    otherAmount: otherSum
  }
}

function joinDrawingGroup (groupDrawings) {
  return groupDrawings.kitchen.concat(groupDrawings.vanity).concat(groupDrawings.other)
}

function addUnitInfo () {
  let unitBase = knowledgeBase.unitBase
  let resultList = []
  for (let drawing of allDrawingList) {
    let unitIdList = drawing.units
    let unitList = []
    let unitTypeList = []
    for (let unitId of unitIdList) {
      let unit = unitBase.find(testUnit => {
        return testUnit.unitId === unitId
      })
      if (unit !== undefined) {
        // if unit found, append the unit
        unitList.push(unit)
        let unitType = unit.type
        if (!unitTypeList.includes(unitType)) {
          // if unitType is new, append to the type
          unitTypeList.push(unitType)
        }
      }
    }
    drawing.unitStr = sortUnitStr(unitList)
    drawing.unitTypeStr = unitTypeList.join(',')
    resultList.push(drawing)
  }
  return resultList
}

function sortUnitStr (unitList) {
  // assemble tireNameList and sort
  // console.log('unitList', unitList)
  let tireNameList = []
  for (let unit of unitList) {
    let tier = unit.tier
    if (!tireNameList.includes(tier)) {
      tireNameList.push(tier)
    }
  }
  tireNameList.sort()
  // console.log('tireNameList', tireNameList)

  let unitGroups = []
  // group unit based tier
  for (let unit of unitList) {
    let tier = unit.tier
    let index = tireNameList.indexOf(tier)
    if (unitGroups[index] !== undefined) {
      unitGroups[index].push(unit)
    } else {
      unitGroups[index] = [unit]
    }
  }
  // console.log('unitGroups', unitGroups)

  // sort each group
  for (let i = 0; i < unitGroups.length; i++) {
    unitGroups[i].sort((unitA, unitB) => {
      if (unitA.building !== unitB.building) {
        return unitA.building.localeCompare(unitB.building)
      } else if (unitA.floor !== unitB.floor) {
        return parseInt(unitA.floor) - parseInt(unitB.floor)
      } else {
        return 0
      }
    })
  }
  // console.log('unitGroups(sorted)', unitGroups)

  // stringify each group
  let unitGroupStrings = []
  for (let unitGroup of unitGroups) {
    // console.log(unitGroup)
    let tier = unitGroup[0].tier
    let str = '#' + tier + '(L'
    for (let unit of unitGroup) {
      let unitStr = String(unit.floor) + (unit.building === 'Default' ? ', ' : `[${unit.building}], `)
      str = str + unitStr
    }
    str = str.slice(0, -2) // remove last ', '
    str = str + ')'
    unitGroupStrings.push(str)
  }
  let joinedString = unitGroupStrings.join('\n')
  return joinedString
}

function fetchFullItemList () {
  let itemIdList = []
  let rawItemList = []
  for (let drawing of allDrawingList) {
    for (let item of drawing.items) {
      if (!itemIdList.includes(item.itemId)) {
        itemIdList.push(item.itemId)
        rawItemList.push(item)
      }
    }
  }
  // get item list with all info
  let fullItemList = rawItemList.map(rawItem => {
    let fullItem = getFullItemInfo(rawItem.itemId)
    return fullItem
  })

  fullItemList.sort((itemA, itemB) => {
    // sort on color, if color same, sort using name
    return itemA.color.localeCompare(itemB.color) === 0
      ? itemA.model.localeCompare(itemB.model)
      : itemA.color.localeCompare(itemB.color)
  })
  // console.log('full item list =>', fullItemList)
  return fullItemList
}

function getFullItemInfo (itemId) {
  let itemBase = knowledgeBase.itemBase
  let colorBase = knowledgeBase.colorBase
  let itemInfo = itemBase.find(item => {
    return item.itemId === itemId
  })
  let colorInfo = colorBase.find(color => {
    return itemInfo.colorId === color.colorId
  })
  itemInfo.color = colorInfo.name
  itemInfo.tag = colorInfo.tag
  return itemInfo
}

function getItemDisplayArray (fullItemList) {
  // fullItemList is sorted by color
  if (fullItemList.length === 0) {
    console.warn('No item')
    return 0
  }
  let currentColor = fullItemList[0].color
  let itemDisplayArray = [{
    itemId: 'COLOR_HEAD',
    str: currentColor,
    bg: fullItemList[0].tag,
    handle: 0,
    hinge: 0,
    glide: 0
  }]
  for (let item of fullItemList) {
    if (item.color === currentColor) {
      itemDisplayArray.push({
        itemId: item.itemId,
        str: item.model,
        bg: WHITE,
        handle: item.handle,
        hinge: item.hinge,
        glide: item.glide
      })
    } else {
      currentColor = item.color
      itemDisplayArray.push({
        itemId: 'COLOR_HEAD',
        str: currentColor,
        bg: item.tag,
        handle: 0,
        hinge: 0,
        glide: 0
      })
      itemDisplayArray.push({
        itemId: item.itemId,
        str: item.model,
        bg: WHITE,
        handle: item.handle,
        hinge: item.hinge,
        glide: item.glide
      })
    }
  }
  return itemDisplayArray
}

function getItemQtyTable (allDrawingList, itemDisplayArray) {
  let qtyTable = []
  for (let itemHead of itemDisplayArray) {
    let itemId = itemHead.itemId
    let row = []
    for (let drawing of allDrawingList) {
      let items = drawing.items
      let matchItem = items.find(item => {
        return item.itemId === itemId
      })
      if (matchItem === undefined) {
        row.push({
          bg: WHITE,
          qty: 0
        })
      } else {
        row.push({
          bg: matchItem.qty > 0 ? GREEN : WHITE,
          qty: matchItem.qty
        })
      }
    }
    qtyTable.push(row)
  }
  return qtyTable
}

function getItemTotalTable (itemQtyTable, unitMultiplierArray) {
  let totalTable = []
  for (let i = 0; i < itemQtyTable.length; i++) {
    let qtyRow = itemQtyTable[i]
    let totalRow = []
    for (let j = 0; j < qtyRow.length; j++) {
      totalRow.push({
        bg: qtyRow[j].bg,
        qty: qtyRow[j].qty * unitMultiplierArray[j]
      })
    }
    totalTable.push(totalRow)
  }
  return totalTable
}

function getItemTotalArray (itemTotalTable) {
  let totalArray = []
  for (let row of itemTotalTable) {
    let sum = 0
    for (let total of row) {
      sum += total.qty
    }
    totalArray.push(sum)
  }
  return totalArray
}

function getPageTypeAmount (allDrawingList) {
  let kitchenDrawingAmount = 0
  let vanityDrawingAmount = 0
  let otherDrawingAmount = 0
  for (let drawing of allDrawingList) {
    // console.log(drawing.type)
    if (drawing.type === 'Kitchen') {
      kitchenDrawingAmount++
    } else if (drawing.type === 'Vanity') {
      vanityDrawingAmount++
    } else {
      otherDrawingAmount++
    }
  }
  return {
    kitchenDrawingAmount: kitchenDrawingAmount,
    vanityDrawingAmount: vanityDrawingAmount,
    otherDrawingAmount: otherDrawingAmount
  }
}

function getUnitsHeadArray (unitsData) {
  let unitsIdList = []
  let unitsList = []
  for (let unit of unitsData) {
    let unitId = unit.unitId
    if (!unitsIdList.includes(unitId)) {
      unit.str = unit.display + unit.building === 'Default' ? '' : `[${unit.building}]`
      unit = addDrawingPageId(unit)
      unitsList.push(unit)
    }
  }
  // sort the units
  unitsList.sort((unitA, unitB) => {
    if (unitA.building !== unitB.building) {
      return unitA.building.localeCompare(unitB.building)
    } else if (unitA.floor !== unitB.floor) {
      return parseInt(unitA.floor) - parseInt(unitB.floor)
    } else {
      return parseInt(unitA.tier) - parseInt(unitB.tier)
    }
  })
  // console.log('units list =>')
  // console.table(unitsList, ['building','floor','tier'])
  return unitsList
}

function addDrawingPageId (unit) {
  let unitId = unit.unitId

  let pageIdTable = {
    Kitchen: [],
    Vanity: [],
    Other: []
  }

  for (let drawing of allDrawingList) {
    let units = drawing.units
    if (units.includes(unitId)) {
      pageIdTable[drawing.type].push(drawing.pageId)
    }
  }
  unit.pageIdTable = pageIdTable
  return unit
}

function calcPackingQtyTable (unitsHeadArray, itemDisplayArray) {
  let qtyTable = Array(itemDisplayArray.length).fill().map(() => Array(unitsHeadArray.length).fill(0))
  for (let drawing of allDrawingList) {
    let items = drawing.items
    let units = drawing.units
    for (let unitId of units) {
      let x = unitsHeadArray.findIndex(unit => {
        return unit.unitId === unitId
      })
      if (x === -1) {
        continue
      }
      for (let item of items) {
        let itemId = item.itemId
        let y = itemDisplayArray.findIndex(item => {
          return item.itemId === itemId
        })
        if (y === -1) {
          continue
        }
        qtyTable[y][x] += item.qty
      }
    }
  }
  return qtyTable
}

function calcPackingTotalTable (packingQtyTable) {
  let totalArray = []
  for (let row of packingQtyTable) {
    let sum = 0
    for (let qty of row) {
      sum += qty
    }
    totalArray.push(sum)
  }
  return totalArray
}

function fetchPageInfo (pageId) {
  let drawing = allDrawingList.find(drawing => {
    return drawing.pageId === pageId
  })
  if (drawing) {
    return {
      revision: drawing.revision,
      updateOn: drawing.updateDate
    }
  }
  return null
}



//////////////////
// WEBPACK FOOTER
// ./static/js/exportService.js
// module id = null
// module chunks = 